const stepsEnum = {
  TERMS_AND_CONDITIONS: 'terms-conditions',
  ACCOUNT: 'account',
  USER_DETAILS: 'user-details',
  SOUL_FOCUS: 'soul-focus',
};

const stepsArray = [
  {
    ref: stepsEnum.TERMS_AND_CONDITIONS,
    message: 'Accept terms and conditions',
    completed: null,
    component: 'registration-step-terms-and-conditions-modal',
  },
  {
    ref: stepsEnum.ACCOUNT,
    message: 'Share data through PWR Lab',
    completed: null,
    component: 'registration-step-account-modal',
  },
  {
    ref: stepsEnum.USER_DETAILS,
    message: 'Please, provide some details',
    completed: null,
    component: 'registration-step-user-details',
  },
  {
    ref: stepsEnum.SOUL_FOCUS,
    message: 'Click here to register (free)',
    completed: null,
    component: 'registration-step-soul-focus',
  },
];

export { stepsArray, stepsEnum };
